/*
 * Projet: frontgen
 * Version: 7.1.0
 */
(function($){
    // Delegate .transition() calls to .animate()
    // if the browser can't do CSS transitions.
    if (!$.support.transition) $.fn.transition = $.fn.animate;

    /**
     * Locale de la page courante
     */
    var locale = $('html').attr('lang');

    /**
     * Initialisation des champs de type date
     */
    $('.type_date').datepicker($.datepicker.regional[locale]);

    /**
     * Les rubriques externes doivent s'ouvrir dans des nouvelles
     * @PatchAnnotation :
     *      ticket : UTTTMA-310,
     *      commentaire : certains liens externes du projet ne sont pas sensé s'ouvrir dans un nouvel onglet, mais dans une popin,
     *      modalité de supression : ne pas supprimer sauf si le produit ajoute une fonctionnalité similaire.
     */
    $('.type_rubrique_0004, .lien_externe:not(.js-open-in-iframe-popin)').click(function() {
        window.open(this.href);
        return false;
    });

    $('.js-force-reload').click(function() {
        window.location.reload(true);
    });

    // Fonctionnalité de visualisation d'une image
    $('a[data-imgmagnifier]').magnificPopup({
        type: 'image'
    });
})(jQuery.noConflict());
